import { IXetHocVuActionTypes } from "../../action-types/xet-hoc-vu/IXetHocVuActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXetHocVuReducer } from "../../reducer-model/xet-hoc-vu/IXetHocVuReducer";

const iniState: IXetHocVuReducer = {
    status: eReducerStatusBase.is_not_initialization,
    xetLenLops: [],
    id_dot_xet: 0,
    id_he: 0,
    id_khoa: 0,
    khoa_hoc: 0,
    id_chuyen_nganh: 0,
    id_lop: 0,
    id_khoi_nganh: 0,
    isHienThiBoLocLopXet: false,
    isHienThiTheoTrangThai: false,
};

export const xetHocVuReducer = (state : IXetHocVuReducer = iniState, action: IXetHocVuActionTypes): IXetHocVuReducer => {
    switch (action.type) {
       case "XET_HOC_VU_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_HOC_VU_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xetLenLops: action.payload,
            };
        case "XET_HOC_VU_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_HOC_VU_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                isShowProcessing: true,
                processId: action.payload?.process_id || undefined,
            };
        case "XET_HOC_VU_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XET_HOC_VU_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_HOC_VU_CLOSE_PROCESSING_MODAL":
            return {
                ...state,
                isShowProcessing: false
            };
        case "XET_HOC_VU_SHOW_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: true
            };
        case "XET_HOC_VU_CLOSE_THAM_SO_MODAL":
            return {
                ...state,
                isShowThamSoModal: false
            };
        case "XET_HOC_VU_CHANGE_ID_DOT_XET":
            return {
                ...state,
                id_dot_xet: action.payload,
                id_he: 0,
                id_khoa: 0,
                khoa_hoc: 0,
                id_chuyen_nganh: 0,
                id_lop: 0,
            };
        case "XET_HOC_VU_CHANGE_ID_HE":
            return {
                ...state,
                id_he: action.payload
            };
        case "XET_HOC_VU_CHANGE_ID_KHOA":
            return {
                ...state,
                id_khoa: action.payload
            };
        case "XET_HOC_VU_CHANGE_KHOA_HOC":
            return {
                ...state,
                khoa_hoc: action.payload
            };
        case "XET_HOC_VU_CHANGE_ID_CHUYEN_NGANH":
            return {
                ...state,
                id_chuyen_nganh: action.payload
            };
        case "XET_HOC_VU_CHANGE_ID_LOP":
            return {
                ...state,
                id_lop: action.payload
            };
        case "XET_HOC_VU_CHANGE_IS_HIEN_THI_BO_LOC_LOP_XET":
            return {
                ...state,
                isHienThiBoLocLopXet: action.payload
            };
        case "XET_HOC_VU_CHANGE_ID_KHOI_NGANH":
            return {
                ...state,
                id_khoi_nganh: action.payload
            };
        case "XET_HOC_VU_CHANGE_IS_HIEN_THI_THEO_TRANG_THAI":
            return {
                ...state,
                isHienThiTheoTrangThai: action.payload
            };
        default:
            return state;
    }

}